import { render } from "./productionSubject.vue?vue&type=template&id=0f83945a&scoped=true&ts=true"
import script from "./productionSubject.vue?vue&type=script&lang=ts"
export * from "./productionSubject.vue?vue&type=script&lang=ts"

import "./productionSubject.vue?vue&type=style&index=0&id=0f83945a&lang=scss&scoped=true"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f83945a"]])

export default __exports__